import $ from 'jquery';
import { translate } from '@openclassrooms/translations';

import widgetFactory from '../widgetFactory';
import confirmService from '../../Services/confirm';

const widgetName = 'ajaxUpload';

const widget = widgetFactory(widgetName, {
  options: {
    endpoint: '/img/upload',
    maxsize: 102400,
    validityCheck: false,
    immediatePreview: false,
  },

  _create: function () {
    this._super(widgetName);

    this.elements.$fileInput = this.getWidgetElement('input');
    this.elements.$preview = this.getWidgetElement('preview');
    this.elements.$remove = this.getWidgetElement('remove');
    this.elements.$actions = this.getWidgetElement('actions');
    this.elements.$removeInput = this.getWidgetElement('removeInput');
    this.elements.$removeInputContainer = this.getWidgetElement('removeInputContainer');

    this.elements.$form = this.element.closest('form');

    this.elements.$removeInputContainer.css({ position: 'absolute', left: '-999999px' });
    this.elements.$fileInput.on('change', this._onSelectFile.bind(this));
    this.elements.$remove.on('click', this._onRemoveImage.bind(this));

    this._hasImage = !(this.elements.$preview.css('background-image') === 'none');

    this._updateRemoveButtonVisibility();
    this._updateEmptyState();
  },

  _updateEmptyState: function () {
    this.element.toggleClass('is-empty', !this.hasImage());
  },

  _updateRemoveButtonVisibility: function () {
    this.elements.$remove.toggle(this.hasImage());
  },

  _onRemoveImage: function (e) {
    e.preventDefault();

    this.elements.$removeInput.prop('checked', true);
    this.elements.$fileInput.val('');
    this._removePreview();
    this._updateRemoveButtonVisibility();
    this._ajaxPost().always(
      function () {
        this.elements.$removeInput.prop('checked', false);
      }.bind(this)
    );
  },

  _onSelectFile: function (e) {
    var file = this.elements.$fileInput[0].files[0],
      self = this;

    if (this.options.validityCheck && !this._validateFile(file)) {
      return;
    }

    if (this.options.immediatePreview) {
      this._getImage(file, function (result) {
        self._updatePreview(result);
      });
    }

    this._ajaxPost(file);
  },

  _ajaxPost: function (file) {
    var self = this;

    this._setLoadingState(true);

    return $.ajax({
      type: 'POST',
      url: this.elements.$form.attr('action'),
      data: new FormData(this.elements.$form[0]),
      contentType: false,
      processData: false,
    })
      .success(function (response) {
        if (response.imageUrl) {
          self._getImage(file, function (result) {
            self._updatePreview(result);
          });
          // to use real url :
          //self._updatePreview(response.imageUrl);
        }
      })
      .error(function (response) {
        var message = 'error',
          json = response.responseJSON;

        if (json) {
          message = json[Object.keys(json)[0]];
        }

        confirmService.show({
          message: message,
        });

        self.elements.$fileInput.val('');

        self._trigger('error', null, message);
      })
      .always(function () {
        self._setLoadingState(false);
      });
  },

  _setLoadingState: function (state) {
    this.loading = state;
    this.element.toggleClass('is-loading', state);
  },

  _updatePreview: function (newUrl) {
    this.elements.$preview.css('background-image', 'url(' + newUrl + ')');
    this._hasImage = true;
    this._updateRemoveButtonVisibility();
    this._updateEmptyState();
  },

  _removePreview: function () {
    this.elements.$preview.css('background-image', '');
    this._hasImage = false;
    this._updateRemoveButtonVisibility();
    this._updateEmptyState();
  },

  hasImage: function () {
    return this._hasImage;
  },

  _getImage: function (file, callback) {
    var reader = new FileReader();

    reader.onload = function (e) {
      callback(e.target.result);
    };

    reader.readAsDataURL(file);
  },

  _validateFile: function (file) {
    var validate = true;

    if (file.size > this.options.maxsize) {
      confirmService.show({
        message: translate('admin.upload.errors.too_big', { size: this.options.maxsize }),
      });

      validate = false;
    }

    return validate;
  },
});

export default widget;
